import React, { useEffect, useState } from "react";
import { Grid, Box } from "@mui/material";
import SiteList from "./SiteList";

import ManageSite from "./ManageSite";

import { Storage, StorageUnit, mockStorages } from "../../storageComponent";
import "../../storageComponent/StorageComponent.css";

import { useDispatch, useSelector } from "react-redux";
import {
  addSiteAction,
  getSingleSitesAction,
  setAddSiteUnitResponse,
} from "../../../../store/reducers/storageSettingSlice";
import ManageUnit from "../../storageComponent/ManageUnit";
import SiteDetail from "./SiteDetail";
import { AssignUnitModal } from "../../storageComponent";

const SiteManagement: React.FC = () => {
  const dispatch = useDispatch();
  const { sites, isAddSiteSuccess, addSiteUnitResponse,siteDetails } = useSelector(
    (state: any) => state.storageSetting,
  );
  const [storages, setStorages] = useState<Storage[]>(mockStorages);
  const [selectedSiteId, setSelectedSiteId] = useState<any>();
  const [filterType, setFilterType] = useState<"all" | "available">("all");

  // Modal states
  const [addStorageModalOpen, setAddStorageModalOpen] = useState(false);
  const [addUnitModalOpen, setAddUnitModalOpen] = useState(false);
  const [assignUnitModalOpen, setAssignUnitModalOpen] = useState(false);
  const [selectedUnitId, setSelectedUnitId] = useState<string | null>(null);
const [isEditMode, setIsEditMode] = useState(false);
  const selectedStorage = storages.find((s) => s.id === selectedSiteId);

  useEffect(() => {
    if (!selectedSiteId && sites?.length > 0) {
      setSelectedSiteId(sites[0].id);
    }
  }, [sites, selectedSiteId]);


  // Assign unit to customer
  const handleAssignUnit = (assignData: {
    customerName: string;
    assignedDate: string;
    notes?: string;
  }) => {
    if (!selectedSiteId || !selectedUnitId) return;

    setStorages((prev) =>
      prev.map((storage) => {
        if (storage.id === selectedSiteId) {
          const updatedUnits = storage.units.map((unit: any) => {
            if (unit.id === selectedUnitId) {
              return {
                ...unit,
                customerName: assignData.customerName,
                assignedDate: assignData.assignedDate,
                isAvailable: false,
              };
            }
            return unit;
          });

          const availableCount = updatedUnits.filter(
            (u: any) => u.isAvailable,
          ).length;

          return {
            ...storage,
            units: updatedUnits,
            availableUnits: availableCount,
          };
        }
        return storage;
      }),
    );

    setSelectedUnitId(null);
  };

  // Open assign modal for specific unit
  const handleOpenAssignModal = (unitId: string) => {
    setSelectedUnitId(unitId);
    setAssignUnitModalOpen(true);
  };

  // Edit unit (placeholder)
  const handleEditUnit = (unitId: string) => {
    console.log("Edit unit:", unitId);
     setSelectedUnitId(unitId);
    setAddUnitModalOpen(true);
  };

  // Delete unit (placeholder)
  const handleDeleteUnit = (unitId: string) => {
    if (!selectedSiteId) return;

    setStorages((prev) =>
      prev.map((storage) => {
        if (storage.id === selectedSiteId) {
          const updatedUnits = storage.units.filter(
            (u: any) => u.id !== unitId,
          );
          const availableCount = updatedUnits.filter(
            (u: any) => u.isAvailable,
          ).length;

          return {
            ...storage,
            units: updatedUnits,
            totalUnits: updatedUnits.length,
            availableUnits: availableCount,
          };
        }
        return storage;
      }),
    );
  };

  // Assign multiple units
  const handleAssignMultiple = () => {
    console.log("Assign multiple units");
    setAssignUnitModalOpen(true);
    // TODO: Implement bulk assign functionality
  };

  const handleClose = () => {
    setAddStorageModalOpen(false);
    //  setIsEditMode(false);
  };

  useEffect(() => {
    if (isAddSiteSuccess) {
      handleClose();
    }
  }, [isAddSiteSuccess]);

  useEffect(() => {
    if (addSiteUnitResponse && selectedSiteId) {
      dispatch(getSingleSitesAction(selectedSiteId));
      dispatch(setAddSiteUnitResponse(false));
    }
  }, [addSiteUnitResponse, selectedSiteId]);

  const handleUnitClose = () => {
    setAddUnitModalOpen(false);
    setSelectedUnitId(null);
  }

const handleAddSite = () => {
  setAddStorageModalOpen(true);
  setIsEditMode(false);
};

const handleUpdateSite = () => {
  if (!selectedSiteId) return;
   setIsEditMode(true);
  dispatch(getSingleSitesAction(selectedSiteId));
};

useEffect(() => {
  if (isEditMode && siteDetails?.id) {
    setAddStorageModalOpen(true);
    setIsEditMode(false);
  }
}, [siteDetails, isEditMode]);

  return (
    <>
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
          sx={{ padding: "0px" }}
        >
          {/* Left Panel - Storage List */}
          <Grid item xs={12} md={3}>
            {/* <Box
              sx={{
                 height: { xs: "auto", md: "100vh" },
                border: "1px solid #C4CDD5",
              }}
            > */}
              <SiteList
                storages={sites}
                selectedSiteId={selectedSiteId}
                setSelectedSiteId={setSelectedSiteId}
                onAddNew={handleAddSite}
                filterType={filterType}
                setFilterType={setFilterType}
              />
            {/* </Box> */}
          </Grid>

          {/* Right Panel - Storage Detail */}
          <Grid item xs={12} md={9}>
            {selectedSiteId ? (
              <Box sx={{ border: "1px solid #C4CDD5", height: "100%" }}>
                <SiteDetail
                  selectedSiteId={selectedSiteId}
                  onAddUnit={() => setAddUnitModalOpen(true)}
                  onAssignUnit={handleOpenAssignModal}
                  onEditUnit={handleEditUnit}
                  onDeleteUnit={handleDeleteUnit}
                  onEditSite={handleUpdateSite}
                  onAssignMultiple={handleAssignMultiple}
                />
              </Box>
            ) : (
              <Box
                sx={{
                  backgroundColor: "#fff",
                  padding: "60px 20px",
                  borderRadius: "8px",
                  textAlign: "center",
                  color: "#999",
                  border: "1px solid #C4CDD5",
                }}
              >
                Please select a storage from the list
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>
      {/* Modals */}
      {/* <ManageStorage
        open={addStorageModalOpen}
        onClose={() => setAddStorageModalOpen(false)}
        onSubmit={handleAddStorage}
      /> */}

      <ManageSite
        open={addStorageModalOpen}
        onHide={handleClose}
        title={"Manage Site"}
        selectedForm={siteDetails?.id && isEditMode ? siteDetails : null}
      />

      {addUnitModalOpen && <ManageUnit
        open={addUnitModalOpen}
        onHide={() => handleUnitClose()}
        selectUser={""}
        selectedSiteId={selectedSiteId}
        selectedUnitId={selectedUnitId}
        title={"Manage Unit"}
        isSmallScreen={false}
      />}

      <AssignUnitModal
        open={assignUnitModalOpen}
        onClose={() => {
          setAssignUnitModalOpen(false);
          setSelectedUnitId(null);
        }}
        onSubmit={handleAssignUnit}
        unitRefNo={
          selectedStorage?.units.find((u: any) => u.id === selectedUnitId)
            ?.refNo
        }
      />
    </>
  );
};

export default SiteManagement;
